/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Seating_Min_RoundsInputs */



/**
* | output |
* | --- |
* | "At least 1 round required" |
*
* @param {Err_Seating_Min_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_seating_min_rounds = /** @type {((inputs?: Err_Seating_Min_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Seating_Min_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 1 ronde est requise")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere al menos 1 ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("É necessária pelo menos 1 rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("È necessario almeno 1 round")
	return /** @type {LocalizedString} */ ("At least 1 round required")
});